const initalState = {
    loading: false,
    workspaceusersquery: null,
    error:null,
    createLoading: false, 
    createError: null, 
    createError500: null, 
    createSuccess: null,
    updateLoading: false, 
    updateError: null,
    updateError500: null,  
    updateSuccess: null,
    deleteLoading: false,
    deleteError: null,
    deleteError500: null,
    deleteSuccess: false,
    reopenLoading: false, 
    reopenError: null,
    reopenError500: null,  
    reopenSuccess: null,
  }
  
  export const query = (state = initalState, action) => {
    switch (action.type) {
      case "REQUEST_ALL_QUERY": {
        return { ...state, loading: true, error: null, createLoading: false, createError: null, createSuccess: null, updateSuccess: null, updateError: null, deleteSuccess: false }
      }
      case "REQUEST_ALL_QUERY_SUCCESS": {
        return { ...state, workspaceusersquery: action.payload, error: null, loading: false, }
      }
      case "REQUEST_ALL_QUERY_FAILED": {
        return { ...state, loading: false, error: action.payload }
      }
      case "CREATE_REQUEST_USERQUERY": {
        return { ...state, createLoading: true, createError: null, createSuccess: null }
      }
      case "CREATE_REQUEST_USERQUERY_SUCCESS": {
        return { ...state, createSuccess: action.payload, createError: null, createLoading: false, }
      }
      case "CREATE_REQUEST_USERQUERY_FAILED": {
        return { ...state, createLoading: false, createError: action.payload }
      }
      case "CREATE_REQUEST_USERQUERY_FAILED_500": {
        return { ...state, createLoading: false, createError500: action.payload } 
      }
      case "UPDATE_REQUEST_USERQUERY": {
        return { ...state, updateLoading: true, updateError: null, updateSuccess: null }
      }
      case "UPDATE_REQUEST_USERQUERY_SUCCESS": {
        return { ...state, updateSuccess: action.payload, updateError: null, updateLoading: false, }
      }
      case "UPDATE_REQUEST_USERQUERY_FAILED": {
        return { ...state, updateLoading: false, updateError: action.payload }
      }
      case "UPDATE_REQUEST_USERQUERY_FAILED_500": {
        return { ...state, updateLoading: false, updateError500: action.payload }
      }
      case "DELETE_REQUEST_USERQUERY": {
        return { ...state, deleteLoading: true, deleteError: null, deleteSuccess: false }
      }
      case "DELETE_REQUEST_USERQUERY_SUCCESS": {
        return { ...state, deleteSuccess: true, deleteError: null, deleteLoading: false, }
      }
      case "DELETE_REQUEST_USERQUERY_FAILED": {
        return { ...state, deleteLoading: false, deleteError: action.payload, deleteSuccess: false }
      }
      case "REOPEN_REQUEST_USERQUERY": {
        return { ...state, reopenLoading: true, reopenError: null, reopenSuccess: null }
      }
      case "REOPEN_REQUEST_USERQUERY_SUCCESS": {
        return { ...state, reopenSuccess: action.payload, reopenError: null, reopenLoading: false, }
      }
      case "REOPEN_REQUEST_USERQUERY_FAILED": {
        return { ...state, reopenLoading: false, reopenError: action.payload }
      }
      case "REOPEN_REQUEST_USERQUERY_FAILED_500": {
        return { ...state, reopenLoading: false, reopenError500: action.payload }
      }
      default: {
        return state
      }
    }
  }
  